<button class="marketData-inputBtn" v-if="modelSetUp" @click.stop.prevent="download" :disabled="!valid(control)">{{ control.data.text }}</button>